<!-- <style>
.filter {
  display: flex;
  align-items: center;
}
.card.card-custom > .card-header {
  flex-direction: column;
}
</style> -->
<template>
  <!--begin::Advance Table Widget 10-->
<div>
  <div class="card card-custom gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">{{ Category }}</span>
      </h3>
      <div class="card-toolbar">
         <b-form-group id="input-group-2" label="" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.name"
            v-on:keyup="(e) => FilterData(e.target.value)"
            placeholder="Search"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>

    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body py-0">
      <!--begin::Table-->
      <!-- <div class="table-responsive">
        <table
          class="table table-head-custom table-vertical-center"
          id="kt_advance_table_widget_4"
        >
          <thead>
            <tr class="text-left">
              <th class="pl-0" style="width: 55px">Status</th>
              <th style="min-width: 55px; max-width: 80px">Line</th>
              <th style="min-width: 140px">
                {{ $t("TRANSLATOR.NAME", { msg: "NAME" }) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in AllProducts">
              <tr v-bind:key="i">
                <td class="pl-0">
                  <span
                    v-if="item.statusRed === 0 && item.statusOrange === 0"
                    class="label label-lg label-inline label-light-success"
                  >
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Navigation/Check.svg" />
                    </span>
                  </span>
                  <span
                    v-if="item.statusRed === 0 && item.statusOrange > 0"
                    class="label label-lg label-inline label-light-warning"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="media/svg/icons/Code/warning-1-circle.svg"
                      />
                    </span>
                  </span>
                  <span
                    v-if="item.statusRed > 0"
                    class="label label-lg label-inline label-light-danger"
                  >
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Code/Warning-2.svg" />
                    </span>
                  </span>
                </td>
                <td>
                  <a
                    v-bind:href="`#/line/${Category}/conveyor/${item.conveyorNumber}`"
                    class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                  >
                    {{ item.lineNumber }}
                  </a>
                </td>
                <td>
                  <a
                    v-bind:href="`#/line/${Category}/conveyor/${item.conveyorNumber}`"
                    class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                  >
                    {{ item.conveyorNumber }} > {{ item.conveyorExtName }}
                  </a>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div> -->
      <!--end::Table-->
    </div>

    <!-- Start of loading animation -->
    <div class="mt-40" v-if="loading">
      <p class="text-6xl font-bold text-center text-gray-500 animate-pulse">
        Loading...
      </p>
    </div>
    <!-- End of loading animation -->
    <!-- Start of error alert -->
    <div class="mt-12 bg-red-50" v-if="error">
      <h3 class="px-4 py-1 text-4xl font-bold text-white bg-red-800">
        {{ error.title }}
      </h3>
      <p class="p-4 text-lg font-bold text-red-900">{{ error.message }}</p>
    </div>
    <!-- End of error alert -->
    <!--end::Body-->
  </div>

  <!-- <div class="card card-custom"> -->
<!--begin::Products-->
<div class="row">
        <template v-for="(product, id) in AllProducts">
          <!--begin::Product-->
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6" v-bind:key="id">
        <div class="card card-custom gutter-b card-stretch">
            <div class="card-body pt-4">
                <div class="d-flex align-items-end mb-7">
                    <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-4 mt-lg-0 mt-3">
                            <div class="symbol symbol-circle symbol-lg-75">
                                <img v-bind:href="`#/shop/${Category}/${product.code}`" class :src=product.url alt="image">
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <a v-bind:href="`#/shop/${Category}/${product.code}`" class="text-dark font-weight-bold text-hover-primary font-size-h6 mb-0">{{ product.category }}</a>
                            <span class="text-muted font-weight-bold">{{ product.name }}</span>
                        </div>
                    </div>
                </div>
                <p class="mb-7">{{ product.name }}</p>
                <div class="mb-7">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="text-dark-75 font-weight-bolder mr-2">Price:</span>
                        <a v-bind:href="`#/shop/${Category}/${product.code}`" class="text-muted text-hover-primary" v-if="product.price !== 0">€ {{ product.price }}</a>
                        <a v-bind:href="`#/shop/${Category}/${product.code}`" class="text-muted text-hover-primary" v-if="product.price === 0">On request</a>
                    </div>
                    <div class="d-flex justify-content-between align-items-cente my-1">
                        <span class="text-dark-75 font-weight-bolder mr-2" v-show="product.externCode === ''">Code:</span>
                        <span class="text-dark-75 font-weight-bolder mr-2" v-show="product.externCode != ''">Extern code:</span>
                        <a v-bind:href="`#/shop/${Category}/${product.code}`" class="text-muted text-hover-primary" v-show="product.externCode === ''">{{ product.code }}</a>
                        <a v-bind:href="`#/shop/${Category}/${product.code}`" class="text-muted text-hover-primary" v-show="product.externCode != ''">{{ product.externCode }}</a>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="text-dark-75 font-weight-bolder mr-2">Series:</span>
                        <span class="text-muted font-weight-bold">{{ product.series }}</span>
                    </div>
                </div>
                <a v-bind:href="`#/shop/${Category}/${product.code}`" class="btn btn-block btn-sm btn-light-primary font-weight-bolder text-uppercase py-4">view</a>
            </div>
        </div>
    </div>
          <!--end::Product-->
        </template>
</div>
<!--end::Products-->

  <!-- </div> -->
</div>
</template>

<script>
import axios from "axios";

export default {
  name: "widget-1",
  props: {
    Category: String,
    // value: String
  },
  data() {
    return {
      checked: false,
      loading: false,
      active: '',
      error: null,
      AllProducts: [],
      filterData: [],
      greenData: [],
      redData: [],
      orangeData: [],
      filterName: "5",
      selected: null,
      form: {
        name: "",
      },
    };
  },
  computed: {},
  components: {},
  // created() {
  //   console.log(this.lineId1);
  // },
  methods: {
    FilterData: function (e) {
      if (e.length >= 3) {
        let newData = this.filterData.filter(
          (item) =>
            item.name.toLowerCase().includes(e.toLowerCase()) || item.code.toLowerCase().includes(e.toLowerCase()) || item.externCode.toLowerCase().includes(e.toLowerCase())
        );
        this.AllProducts = newData;
      }
      if (e.length == 0) {
        this.AllProducts = this.filterData;
      }
    },
  },
  mounted() {
    // this.fetchAllProducts();
    axios
      .get("/shop/getproducts/" + this.Category)
      .then((response) => {
        // console.log(response.data)
        this.AllProducts = response.data;
        this.filterData = response.data;
        // console.log(this.AllProducts)
        // this.getTotal();
      })
      .catch((err) => {
        throw err;
      });
  },
};
</script>
